// extracted by mini-css-extract-plugin
export default {"quantityTag":"quantityTag_quantityTag__eFyuU"};